import { render, staticRenderFns } from "./ShippingAdvise.vue?vue&type=template&id=462e9725"
import script from "./ShippingAdvise.vue?vue&type=script&lang=js"
export * from "./ShippingAdvise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports